import React from "react";
import { Row, Col } from "react-bootstrap";
import HomePageInfoCard from "./HomePageInfoCard";
import { PiStrategy } from "react-icons/pi";
import { IoPodiumOutline, IoTrophyOutline } from "react-icons/io5";
import { FaSignsPost } from "react-icons/fa6";

const HomePageInfoRow: React.FC = () => {
	return (
		<div className="">
			<Row>
				<Col md={3}>
					<HomePageInfoCard
						icon={PiStrategy}
						title="Manage Your Riders"
						text="Spend your budget wisely to build your team"
					/>
				</Col>
				<Col md={3}>
					<HomePageInfoCard
						icon={IoTrophyOutline}
						title="Real Performance Earns Points"
						text="Get points based on your riders' performance"
					/>
				</Col>
				<Col md={3}>
					<HomePageInfoCard
						icon={IoPodiumOutline}
						title="Climb the Leaderboard"
						text="Create a league and compete against your friends"
					/>
				</Col>
				<Col md={3}>
					<HomePageInfoCard
						icon={FaSignsPost}
						title="Don't Miss the actions"
						text="Keep up to date with the races and know where to watch"
					/>
				</Col>
			</Row>
		</div>
	);
};

export default HomePageInfoRow;
